module.exports = __webpack_public_path__ + "img/syukyaku-kyoutu-maru008.aebd77f6.png";